import { MessageCircle } from "lucide-react";
import { CONTACT } from "../data/experiences";

export const WhatsAppFloat = () => (
  <a
    data-testid="whatsapp-float-button"
    href={CONTACT.whatsapp}
    target="_blank"
    rel="noopener noreferrer"
    aria-label="Chat on WhatsApp"
    className="fixed bottom-5 left-5 z-[70] w-12 h-12 bg-maroon text-ivory flex items-center justify-center border border-gold/40 hover:bg-maroon-dark transition-colors duration-200"
  >
    <MessageCircle size={24} />
  </a>
);
